import { render } from "./ManagerPanelHeader.vue?vue&type=template&id=d4d609b6&scoped=true"
import script from "./ManagerPanelHeader.vue?vue&type=script&lang=js"
export * from "./ManagerPanelHeader.vue?vue&type=script&lang=js"

import "./ManagerPanelHeader.vue?vue&type=style&index=0&id=d4d609b6&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4d609b6"]])

export default __exports__